import { RouterModule, Routes } from '@angular/router';

import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

import { TemplateComponent } from './templates/template.component';

import { LoginSuccessComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';

const appRoutes: Routes = [
  {
    path: '',
    component: TemplateComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'login',
        component: LoginSuccessComponent,
        canActivate: [AutoLoginPartialRoutesGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];

export const routing = RouterModule.forRoot(appRoutes);
